<template lang="pug">
#actions.md-flex
  md-content.md-layout-row.md-gutter.md-elevation-1(md-theme="white")
    module-menu
    .md-flex(md-theme="white")
</template>

<script>
  import ModuleMenu from './menu.vue';

  export default {
      data() {
          return {
            title: ''
          }
      },
      components: {
        ModuleMenu
      },
      computed: {

      },
      metaInfo() {
          return {

          }
      },
      created() {

      },
      methods: {

      }
  }
</script>



// WEBPACK FOOTER //
// Module.vue?7cbbe003